var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCricket = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Cricket-Bat-Ball--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Cricket Bat Ball Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.25a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0 -6.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.56 4 20 0.44a1.54 1.54 0 0 0 -2.13 0L7.72 10.63a0.48 0.48 0 0 0 0 0.7l5 5a0.49 0.49 0 0 0 0.35 0.15 0.47 0.47 0 0 0 0.35 -0.15L23.56 6.1A1.52 1.52 0 0 0 24 5a1.5 1.5 0 0 0 -0.44 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66 12.39a0.5 0.5 0 0 0 -0.52 -0.11 0.49 0.49 0 0 0 -0.33 0.41l-0.3 2.66a1 1 0 0 1 -0.29 0.6L0.29 20.88a1 1 0 0 0 0 1.41l1.42 1.42a1 1 0 0 0 1.41 0l4.93 -4.93a1 1 0 0 1 0.6 -0.29l2.66 -0.3a0.49 0.49 0 0 0 0.41 -0.33 0.5 0.5 0 0 0 -0.11 -0.52Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCricket);
export default ForwardRef;